import { Controller } from "@hotwired/stimulus"
import {debounce} from "../libs/utils";

/**
 * Make forms to submit when a new change is made in one of its inputs
 *
 * @example
 * <form data-controller="autosubmit">
 *   <input />
 * </form>
 */

export default class SubmitNowController extends Controller {
  static values = {
    delay: Number,
  }

  initialize() {
    const delay = (this.delayValue === 0) ? 0 : this.delayValue;

    this.doSubmit = debounce(this.doSubmit.bind(this), delay)

    setTimeout(() => {
      this.doSubmit();
    }, delay);
  }

  doSubmit() {
    this.element.click();
  }
}
